import { __asyncGenerator, __await, __generator } from "tslib";
/**
 * Convert ReadableStream into an async iterable.
 */

export function ReadableStreamtoIterable(readableStream) {
  return __asyncGenerator(this, arguments, function ReadableStreamtoIterable_1() {
    var reader, done, _a, end, value;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          reader = readableStream.getReader();
          done = false;
          _b.label = 1;

        case 1:
          if (!!done) return [3
          /*break*/
          , 6];
          return [4
          /*yield*/
          , __await(reader.read())];

        case 2:
          _a = _b.sent(), end = _a.done, value = _a.value;

          if (end) {
            done = true;
            return [3
            /*break*/
            , 6];
          }

          if (!value) return [3
          /*break*/
          , 5];
          return [4
          /*yield*/
          , __await(value)];

        case 3:
          return [4
          /*yield*/
          , _b.sent()];

        case 4:
          _b.sent();

          _b.label = 5;

        case 5:
          return [3
          /*break*/
          , 1];

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  });
}